import React from 'react'
import {
  AutoComplete,
  AutoCompleteInput,
  AutoCompleteItem,
  AutoCompleteList,
} from '@choc-ui/chakra-autocomplete'
import { FiChevronDown, FiChevronRight } from 'react-icons/fi'
import { Icon, InputGroup, InputRightElement, Text } from '@chakra-ui/react'

type Item = {
  value: string
  label: string
}
interface SearchDropdownProps {
  onChange?: (item: unknown) => void
  items?: Item[]
  placeholder?: string
}
function SearchDropdown({
  onChange,
  items,
  placeholder,
  ...rest
}: SearchDropdownProps) {
  return (
    <AutoComplete
      openOnFocus
      maxSuggestions={50}
      onSelectOption={onChange}
      {...rest}>
      {({ isOpen }) => (
        <>
          <InputGroup>
            <AutoCompleteInput
              p={0}
              fontSize={24}
              fontWeight={600}
              variant="filled"
              placeholder={placeholder ?? 'Search...'}
              bg="transparent"
              outline="none"
              border="none"
              borderBottom="1px solid"
              borderBottomColor="brand.lightGray"
              paddingBottom="12px"
              _hover={{
                cursor: 'pointer',
              }}
              _focus={{
                outline: 'none',
                border: 'none',

                borderBottom: '1px solid',
                paddingBottom: '12px',
              }}
            />
            <InputRightElement
              children={<Icon as={isOpen ? FiChevronRight : FiChevronDown} />}
            />
          </InputGroup>
          <AutoCompleteList>
            {items?.map((item, cid) => (
              <AutoCompleteItem
                key={`option-${cid}`}
                value={item.value}
                textTransform="capitalize">
                <Text>{item.label}</Text>
              </AutoCompleteItem>
            ))}
          </AutoCompleteList>
        </>
      )}
    </AutoComplete>
  )
}

export default SearchDropdown
